import { shiftReviewAdapter } from './shiftReviewAdapter';
import { IGetPendingReviewPayload, shiftReviewApi } from './shiftReviewApi';
import { IPendingReviewList } from './Types';

const getShiftPendingReviews = async (
  payload: IGetPendingReviewPayload,
): Promise<IPendingReviewList> => {
  const response = await shiftReviewApi.getShiftPendingReviews(payload);

  return shiftReviewAdapter.toPendingReviewList(response);
};

export const shiftReviewService = {
  getShiftPendingReviews,
};
